import useSound from "use-sound";
import {useAppContext} from "../provider/AppProvider";
// @ts-ignore
import click_button from './../assets/sounds/click_button.wav';
// @ts-ignore
import combo from './../assets/sounds/combo.mp3';
// @ts-ignore
import paste_cube from './../assets/sounds/paste_cube.wav';
// @ts-ignore
import bomb from './../assets/sounds/bomb.wav';

const sounds = {
    click_button,
    combo,
    paste_cube,
    bomb,
}

/*
* функция включения звука при каком-либо действии
* */

export const useSoundToggle = (soundFile: keyof typeof sounds, volume: number = 1) => {
    const {sound, onSwitchSound} = useAppContext();
    const [play] = useSound(sounds[soundFile], { volume: volume });

    const playSound = () => {
        if (!sound) return;
        play();
    }


    return {
        isSound: sound,
        onToggleSound: onSwitchSound,
        playSound,
    }
}